// Notification styles for NotificationDrawer

export const badgeSx = (unreadCount) => ({
  '& .MuiBadge-badge': {
    backgroundColor: unreadCount > 0 ? '#FF3333' : 'transparent',
    color: 'white',
    fontWeight: 600,
    fontSize: '0.75rem',
    minWidth: unreadCount > 9 ? '20px' : '16px',
    height: '16px',
    border: '0.5px solid white',
    borderRadius: '50%',
    top: '1px',
    right: '2px',
  },
})

export const drawerPaperSx = {
  width: { xs: '100vw', sm: 420 },
  maxWidth: '100vw',
  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
}

export const drawerHeaderSx = {
  position: 'fixed',
  width: { xs: '100vw', sm: 420 },
  maxWidth: '100vw',
  zIndex: 1,
  backgroundColor: 'white',
  p: { xs: 2, sm: 2.5 },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: '1px solid #f0f0f0',
  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
}

export const emptyStateSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '60vh',
  color: '#aaa',
}

export const notificationListContainerSx = {
  mt: { xs: 8, sm: 7 },
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - 56px)',
}

export const notificationListSx = {
  flex: 1,
  overflowY: 'auto',
  px: { xs: 1, sm: 0 },
}

export const loadMoreBoxSx = {
  borderTop: '1px solid #eee',
  p: 2,
  textAlign: 'center',
}

export const toastBoxSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  bgcolor: '#3366FF',
  color: 'white',
  borderRadius: 1,
  p: 2,
  boxShadow: 3,
  minWidth: 300,
}

export const toastProgressSx = {
  mt: 1,
  height: 4,
  bgcolor: 'rgba(255,255,255,0.2)',
  '& .MuiLinearProgress-bar': { backgroundColor: '#fff' },
  borderRadius: 2,
}

export const listItemSx = (read) => ({
  bgcolor: read ? 'transparent' : 'rgba(25, 118, 210, 0.04)',
  cursor: read ? 'default' : 'pointer',
  opacity: read ? 0.85 : 1,
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: read ? 'rgba(0, 0, 0, 0.02)' : 'rgba(25, 118, 210, 0.08)',
  },
})

export const listItemIconBadgeSx = {
  '& .MuiBadge-badge': { right: -3, top: 3 },
}
